<template>
  <!-- 商品详情/当前价格 tv右下 -->
  <div id="transcc_symbol_msg">
    <div class="flex-wrap">
      <!-- 左列数据  <div class="flex-col flex-lines">-->
        <div class="flex-row" @mousemove="showJS(1)" @mouseout="hideJs(1)">
          <!-- 左列数据 -->
          <div class="flex-col msg">最新价</div>
          <!-- 右列数据 -->
           <el-tooltip class="item" effect="dark" content="当前商品合约最新成交价" placement="left">
              <div class="flex-col msg r" :style="{color:selectItem.closeToClearColor}">{{ nowClosePrice }}</div>
           </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(2)" @mouseout="hideJs(2)">
          <!-- 左列数据 -->
          <div class="flex-col msg">现量</div>
          <!-- 右列数据 -->
           <el-tooltip class="item" effect="dark" content="以最低价成交的最新数量" placement="left">
            <div class="flex-col msg r">{{ selectItem.currencyQuantity&&Number(selectItem.currencyQuantity)==0?'--':Number(selectItem.currencyQuantity).toFixed(selectItem.quantityNum) }}</div>
           </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(3)" @mouseout="hideJs(3)">
          <!-- 左列数据 -->
          <div class="flex-col msg">涨跌</div>
          <!-- 右列数据 --> 
          <el-tooltip placement="left">
            <div slot="content">
              最新价和昨结价之间的差值.<br/>
              涨跌=最新价-昨结价.
            </div>
             <div class="flex-col msg r" :style="{color:selectItem.closeToClearColor}">{{ Number(selectItem.quote).toFixed(selectItem.coinDigitalNum) }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(4)" @mouseout="hideJs(4)">
          <!-- 左列数据 -->
          <div class="flex-col msg">涨跌幅</div>
          <!-- 右列数据 -->
            <el-tooltip placement="left">
              <div slot="content" style="width:178px">
                当日最新价与前一日结算价相比的百分比幅度。<br/>
               涨跌幅=（最新价-昨结价）/昨结价*100%。
              </div>
              <!-- :style="{color:selectItem.quotechangeColor}" -->
            <div class="flex-col msg r" :style="{color:selectItem.quotechangeColor}">{{ selectItem.quotechange | addSign }}</div>
            </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(5)" @mouseout="hideJs(5)">
          <!-- 左列数据 -->
          <div class="flex-col msg">开盘价</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left" content="当天某商品的第一笔成交价">
            <div class="flex-col msg r" :class="Number(selectItem.open)==0?'':'whiteColor'">{{ Number(selectItem.open)==0?'--':Number(selectItem.open).toFixed(selectItem.coinDigitalNum) }}</div>
          </el-tooltip >
        </div>
        <div class="flex-row" @mousemove="showJS(6)" @mouseout="hideJs(6)">
          <!-- 左列数据 -->
          <div class="flex-col msg">结算价</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left" content="当前交易日的收盘价">
            <!-- <div class="flex-col msg r">{{ Number(selectItem.averagePrice)==0?'--':Number(selectItem.averagePrice).toFixed(selectItem.coinDigitalNum) }}</div> -->
            <!-- 李美俊 改下结算价，让他一直等于最新价 -->
            <div class="flex-col msg r">{{ nowClosePrice }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(7)" @mouseout="hideJs(7)">
          <!-- 左列数据 -->
          <div class="flex-col msg">最高价</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left" content="在一定时间内商品合约最高成交价。">
           <div class="flex-col msg r" :class="Number(selectItem.high)==0?'':(Number(selectItem.high)>Number(selectItem.clearPrice)?'redColor':Number(selectItem.high)<Number(selectItem.clearPrice)?'greenColor':'whiteColor')">{{ Number(selectItem.high)==0?'--':Number(selectItem.high).toFixed(selectItem.coinDigitalNum) }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(8)" @mouseout="hideJs(8)">
          <!-- 左列数据 -->
          <div class="flex-col msg">最低价</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left">
            <div slot="content">
              在一定时间内商品合约最低成交价。
            </div>
            <div class="flex-col msg r" :class="Number(selectItem.low)==0?'':(Number(selectItem.low)>Number(selectItem.clearPrice)?'redColor':Number(selectItem.low)<Number(selectItem.clearPrice)?'greenColor':'whiteColor')">{{ Number(selectItem.low)==0?'--':Number(selectItem.low).toFixed(selectItem.coinDigitalNum) }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(9)" @mouseout="hideJs(9)">
          <!-- 左列数据 -->
          <div class="flex-col msg">涨停价</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left">
            <div style="width:178px" slot="content">
              规定了交易价格在一个交易日中的最大波动幅度为前一交易日结算价上涨百分之几。<br/>
              涨停价=昨结价*（1+X%）。
            </div>
            <div class="flex-col msg r redColor">{{ Number(CommodityHighLowGetter.high).toFixed(selectItem.coinDigitalNum) }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(10)" @mouseout="hideJs(10)">
          <!-- 左列数据 -->
          <div class="flex-col msg">跌停价</div>
          <!-- 右列数据 -->
           <el-tooltip placement="left">
            <div slot="content" style="width:178px">
              规定了交易价格在一个交易日中的最大波动幅度为前一交易日结算价下跌百分之几。<br/>
              跌停价=昨结价*（1-X%）
            </div>
            <div class="flex-col msg r greenColor">{{ Number(CommodityHighLowGetter.low).toFixed(selectItem.coinDigitalNum) }}</div>
           </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(11)" @mouseout="hideJs(11)">
          <!-- 左列数据 -->
          <div class="flex-col msg goldColor">存货量</div>
          <!-- 右列数据 -->
          <el-tooltip v-if="APP_WINNY_NAME == '尚志汇农'" placement="left" content="当前商品持货量。">
            <div v-if="selectItem.holdQuantity&&Number(selectItem.holdQuantity)>10000" class="flex-col msg r goldColor">{{ selectItem.holdQuantity&&Number(selectItem.holdQuantity)==0?'--':Number(selectItem.holdQuantity)*2 | amountFixFormat }}</div>
            <div v-else class="flex-col msg r goldColor">{{ (selectItem.holdQuantity&&Number(selectItem.holdQuantity)==0?'--':Number(selectItem.holdQuantity)*2).toFixed(selectItem.quantityNum) }}</div>
          </el-tooltip>
          <el-tooltip v-else placement="left" content="当前商品单边持货量。">
            <div v-if="selectItem.holdQuantity&&Number(selectItem.holdQuantity)>10000" class="flex-col msg r goldColor">{{ selectItem.holdQuantity&&Number(selectItem.holdQuantity)==0?'--':Number(selectItem.holdQuantity) | amountFixFormat }}</div>
            <div v-else class="flex-col msg r goldColor">{{ selectItem.holdQuantity&&Number(selectItem.holdQuantity)==0?'--':Number(selectItem.holdQuantity).toFixed(selectItem.quantityNum) }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(12)" @mouseout="hideJs(12)">
          <!-- 左列数据  msg goldColor  msg r w-->
          <div class="flex-col msg">仓差</div>
          <!-- 右列数据 -->
           <el-tooltip placement="left">
            <div slot="content" style="width:178px">当前订货量和昨日收盘订货量的差值。<br/>仓差=现在的订货量-昨日收盘的订货量。</div>
            <div v-if="APP_WINNY_NAME === '尚志汇农'" class="flex-col msg " style="color: #c7c7c7">{{ (selectItem.warehouseBad&&Number(selectItem.warehouseBad)==0?'--':Number(selectItem.warehouseBad)*2).toFixed(selectItem.quantityNum) }}</div>
            <div v-else class="flex-col msg " style="color: #c7c7c7">{{ (selectItem.warehouseBad&&Number(selectItem.warehouseBad)==0?'--':Number(selectItem.warehouseBad)).toFixed(selectItem.quantityNum) }}</div>
            <!-- selectItem.warehouseBad>0?'redColor':selectItem.warehouseBad<0?'greenColor':'' -->
          </el-tooltip>
        </div>
        <!-- <div class="flex-row">
           <div class="flex-col msg">成交量</div>
          <el-tooltip placement="left">
            <div slot="content">已经成交的合约数量。</div>
             <div class="flex-col msg r" :style="{color:selectItem.closeToClearColor}">{{ nowClosePrice }}</div>
          </el-tooltip>
        </div>
         <div class="flex-row">
            <div class="flex-col msg">成交额</div>
            <el-tooltip placement="left">
              <div slot="content">已经成交的合约金额。</div>
              <div class="flex-col msg r" :style="{color:selectItem.closeToClearColor}">{{ nowClosePrice }}</div>
            </el-tooltip>
         </div> -->
        <!-- <div class="flex-row" @mousemove="showJS(13)" @mouseout="hideJs(13)"> -->
        <!-- 左列数据 -->
        <!-- <div class="flex-col msg">成交量</div> -->
        <!-- 右列数据 -->
        <!-- <div v-if="selectItem.amount&&Number(selectItem.amount)>10000" class="flex-col msg r" :class="Number(selectItem.amount)==0?'':'whiteColor'">{{ Number(selectItem.amount)==0?'--':Number(selectItem.amount) | amountFixFormat }}</div> -->
        <!-- <div v-else class="flex-col msg r" :class="Number(selectItem.amount)==0?'':'whiteColor'">{{ Number(selectItem.amount)==0?'--':Number(selectItem.amount).toFixed(selectItem.quantityNum) }}</div> -->
        <!-- </div> -->
        <div class="flex-row" @mousemove="showJS(15)" @mouseout="hideJs(15)">
          <!-- 左列数据 -->
          <div class="flex-col msg">昨收价</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left" content="上一交易日的最后成交价。">
            <div class="flex-col msg r" :class="Number(selectItem.yescloseprice)==0?'':'whiteColor'">{{ Number(selectItem.yescloseprice)==0?'--':Number(selectItem.yescloseprice).toFixed(selectItem.coinDigitalNum) }}</div>
          </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(16)" @mouseout="hideJs(16)">
          <!-- 左列数据 -->
          <div class="flex-col msg">昨结价</div>
          <!-- 右列数据 -->
           <el-tooltip placement="left" content="上一交易日的最后结算价。">
             <div class="flex-col msg r goldColor">{{ Number(selectItem.clearPrice)==0?'--':Number(selectItem.clearPrice).toFixed(selectItem.coinDigitalNum) }}</div>
           </el-tooltip>
        </div>
        <div class="flex-row" @mousemove="showJS(18)" @mouseout="hideJs(18)">
          <!-- 左列数据 -->
          <div class="flex-col msg">外盘</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left" content="买方主动以高于或等于盘口销售的价格成交的数量">
            <div v-if="selectItem.buyCount&&Number(selectItem.buyCount)>10000" class="flex-col msg r" :class="Number(selectItem.buyCount)==0?'':'redColor'">{{ Number(selectItem.buyCount)==0?'--':Number(selectItem.buyCount) | amountFixFormat }}</div>
            <div v-else class="flex-col msg r" :class="Number(selectItem.buyCount)==0?'':'redColor'">{{ Number(selectItem.buyCount)==0?'--':Number(selectItem.buyCount).toFixed(selectItem.quantityNum) }}</div>
          </el-tooltip>
        </div>
        <!-- <div class="flex-row" @mousemove="showJS(17)" @mouseout="hideJs(17)"> -->
        <!-- 左列数据 -->
        <!-- <div class="flex-col msg">换手率</div> -->
        <!-- 右列数据 -->
        <!-- <div class="flex-col msg r ">{{ selectItem&&selectItem.turnoverRate&&typeof(selectItem.turnoverRate)==='number'? (selectItem.turnoverRate*100).toFixed(2) : '0' }}%</div> -->
        <!-- </div> -->
      <!-- 右列数据  <div class="flex-col flex-right-lines">-->
        <!-- <div class="flex-row" @mousemove="showJS(14)" @mouseout="hideJs(14)"> -->
        <!-- 左列数据 -->
        <!-- <div v-if="selectItem.totalAmount&&Number(selectItem.totalAmount)>10000" class="flex-col msg">成交额<span style="float:right">{{ Number(selectItem.totalAmount) | amountFixFormat }}</span></div> -->
        <!-- <div v-else class="flex-col msg">成交额<span style="float:right">{{ Number(selectItem.totalAmount)==0?'--':Number(selectItem.totalAmount).toFixed(selectItem.quantityNum) }}</span></div> -->
        <!-- 右列数据 -->
        <!-- <div class="flex-col msg r">{{ Number(selectItem.totalAmount) | amountFixFormat }}</div> -->
        <!-- </div> -->
        <!-- <div class="flex-row" @mousemove="showJS(17)" @mouseout="hideJs(17)"> -->
        <!-- 左列数据 -->
        <!-- <div class="flex-col msg"></div> -->
        <!-- 右列数据 -->
        <!-- <div class="flex-col msg r "></div> -->
        <!-- <div class="flex-col msg r ">{{ selectItem&&selectItem.turnoverRate&&typeof(selectItem.turnoverRate)==='number'? (selectItem.turnoverRate*100).toFixed(2) : '0' }}%</div> -->
        <!-- </div> -->
        <div class="flex-row" @mousemove="showJS(19)" @mouseout="hideJs(19)">
          <!-- 左列数据 -->
          <div class="flex-col msg">内盘</div>
          <!-- 右列数据 -->
          <el-tooltip placement="left" content="卖方主动以低于或等于盘口采购的价格成交的数量">
            <div v-if="selectItem.sellCount&&Number(selectItem.sellCount)>10000" class="flex-col msg r" :class="Number(selectItem.sellCount)==0?'':'greenColor'">{{ Number(selectItem.sellCount)==0?'--':Number(selectItem.sellCount) | amountFixFormat }}</div>
            <div v-else class="flex-col msg r" :class="Number(selectItem.sellCount)==0?'':'greenColor'">{{ Number(selectItem.sellCount)==0?'--':Number(selectItem.sellCount).toFixed(selectItem.quantityNum) }}</div>
          </el-tooltip>
        </div>
      </div>
    <!-- <div v-if="isShowCalcFor" class="calcFormula" :style="`left:${nounFormula[explainId].left};bottom:${nounFormula[explainId].bottom}`">
      <div class="interprete">{{ nounFormula[explainId].noun }}</div>
      <div class="calcFor">
        {{ nounFormula[explainId].formula }}
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      // 下为支持数据,源自行情组件
      isShowCalcFor: false, // 名词解释计算公式弹框
      nounFormula: [
        {
          id: 0,
          noun: '当日成交量与持仓量的对比关系，换手率越大说明当日交易越活跃。',
          formula: '换手率=当日成交量/持仓量*100%',
          left: '-270px',
          bottom: '30px'
        },
        { // 最新价
          id: 1,
          noun: '当前商品合约最新成交价',
          formula: '',
          left: '-270px',
          bottom: '165px'
        },
        { // 现量
          id: 2,
          noun: '以最新价成交的合约数量。',
          formula: '',
          left: '-140px',
          bottom: '165px'
        },
        { // 涨跌
          id: 3,
          noun: '最新价和昨结价之间的差值。',
          formula: '涨跌=最新价-昨结价。',
          left: '-270px',
          bottom: '165px'
        },
        { // 涨跌幅
          id: 4,
          noun: '当日最新价与前一日结算价相比的百分比幅度。',
          formula: '涨跌幅=（最新价-昨结价）/昨结价*100%。',
          left: '-140px',
          bottom: '165px'
        },
        { // 开盘价
          id: 5,
          noun: '当天某商品的第一笔成交价。',
          formula: '',
          left: '-270px',
          bottom: '151px'
        },
        { // 结算价
          id: 6,
          noun: '全天成交价按照分时成交量的加权平均价。',
          formula: '',
          left: '-140px',
          bottom: '151px'
        },
        { // 当日最高
          id: 7,
          noun: '在一定时间内商品合约最高成交价。',
          formula: '',
          left: '-270px',
          bottom: '134px'
        },
        { // 当日最低
          id: 8,
          noun: '在一定时间内商品合约最低成交价。',
          formula: '',
          left: '-140px',
          bottom: '134px'
        },
        { // 涨停价
          id: 9,
          noun: '规定了交易价格在一个交易日中的最大波动幅度为前一交易日结算价上涨百分之几。',
          formula: '涨停价=昨结价*（1+X%）。',
          left: '-270px',
          bottom: '120px'
        },
        { // 跌停价
          id: 10,
          noun: '规定了交易价格在一个交易日中的最大波动幅度为前一交易日结算价下跌百分之几。',
          formula: '跌停价=昨结价*（1-X%）',
          left: '-140px',
          bottom: '120px'
        },
        { // 订货量
          id: 11,
          noun: window.g.APP_WINNY_NAME === '硒交在线' ? '当前商品单边持货量。' : '当前商品双边持货量。',
          formula: '',
          left: '-270px',
          bottom: '106px'
        },
        { // 仓差
          id: 12,
          noun: '当前订货量和昨日收盘订货量的差值。',
          formula: '仓差=现在的订货量-昨日收盘的订货量。',
          left: '-140px',
          bottom: '106px'
        },
        { // 成交量
          id: 13,
          noun: '已经成交的合约数量。',
          formula: '',
          left: '-270px',
          bottom: '92px'
        },
        { // 成交额
          id: 14,
          noun: '已经成交的合约金额。',
          formula: '',
          left: '-140px',
          bottom: '92px'
        },
        { // 昨收价
          id: 15,
          noun: '上一交易日的最后成交价。',
          formula: '',
          left: '-270px',
          bottom: '78px'
        },
        { // 昨结价
          id: 16,
          noun: '上一交易日的最后结算价。',
          formula: '',
          left: '-140px',
          bottom: '78px'
        },
        { // 换手率
          id: 17,
          noun: '当日成交量与持仓量的对比关系，换手率越大说明当日交易越活跃。',
          formula: '换手率=该品种当日的成交量/该品种的持仓量。',
          left: '-270px',
          bottom: '30px'
        },
        { // 外盘
          id: 18,
          noun: '买方主动以高于或等于盘口销售的价格成交的数量',
          formula: '',
          left: '-270px',
          bottom: '64px'
        },
        { // 内盘
          id: 19,
          noun: '卖方主动以低于或等于盘口采购的价格成交的数量',
          formula: '',
          left: '-270px',
          bottom: '64px'
        }
      ],
      explainId: 0
    }
  },
  computed: {
    ...mapGetters(['marketDetails', 'systemTimeGetter', 'marketStatusInNewTopline', 'CommodityHighLowGetter']),
    item() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        return this.$store.state.hqData.item.symbol
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol
        } else {
          return '--'
        }
      }
    },
    selectItem() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        for (let index = 0; index < this.$store.state.hqData.marketDetails.length; index++) {
          const element = this.$store.state.hqData.marketDetails[index]
          if (this.$store.state.hqData.item.symbolId == element.symbolId) {
            return element
          }
        }
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0]
        } else {
          return {
            close: 0.00,
            quotechangeColor: 'white',
            quotechange: 0.00,
            high: 0,
            low: 0,
            amount: 0,
            symbolId: '--',
            clearPrice: 0,
            numStr: /^(\d+)\.(\d{0,2}).*$/,
            coinDigitalNum: 2,
            quantityNum: 2 // 数量
          }
        }
      }
      return ''
    },
    nowClosePrice() {
      return Number(this.selectItem.close).toFixed(this.selectItem.coinDigitalNum)
    }
  },
  watch: {
    nowClosePrice(val, oldVal) {
      document.title = val + ' ' + this.item + ' ' + window.g.APP_TITLE_CLICK
    }
  },
  mounted() {
    document.title = this.nowClosePrice + ' ' + this.item + ' ' + window.g.APP_TITLE_CLICK
  },
  methods: {
    showJS(id) {
      this.explainId = id
      this.isShowCalcFor = true
    },
    hideJs(id) {
      this.explainId = id
      this.isShowCalcFor = false
    }
    // 商品涨停跌停价查询
    // findCommodityHighLow() {
    //   protocol.findCommodityHighLow.data.commodityId = this.symbol
    //   http.gPost(protocol.findCommodityHighLow).then(response => {
    //     if (response.data) {
    //       if (response.data && response.data.code == '0') {
    //         this.CommodityHighLowGetter = response.data.value
    //       }
    //     }
    //   })
    // },
    // changeTime(val) {
    //   if (val != 0) {
    //     this.resetDataTimerData.oldTime = val
    //   } else {
    //     this.resetDataTimerData.oldTime = Number(new Date())
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
#transcc_symbol_msg{
  box-sizing: border-box;
  padding: 0;
  height: 100%;
  width: 100%;
  position: relative;
  .flex-wrap{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    .flex-row{
      position: relative;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     flex: 0 0 25%;
     .msg{
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #989898;
      margin-bottom: 9px;
     }
     .msg:nth-of-type(2){
      padding: 3px 10px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #C7C7C7;
     }
    }
  }
  .flex-row:hover .msg:nth-of-type(2){
      background: rgba($color: #ffffff, $alpha: 0.24);
     
      color: #c7c7c7;
  }
  .calcFormula{
    position: absolute;
    left:-270px;
    bottom:30px;
    z-index: 100;
    background-color: #2C2C2C;
    width:252px;
    padding:14px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    div{
     color:#fff;
    }
  }
  .flex-lines{
    padding: 0 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .flex-right-lines{
    flex: 1;
  }
  .flex-lines>div:hover{
    background: rgba(255,255,255,0.16);
    border-radius: 2px;
  }
  .flex-lines:last-child{
    padding:0 14px 0 0;
  }
  .msg{
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.5);
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    span{
      color: rgba(255, 255, 255, 0.5);
    }
  }
  .flex-row,.moveFlag{
    cursor: pointer;
  }
  .r{
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .w{
    font-weight: bold;
  }
  .goldColor{
    color: #FFD700;
    font-size: 15px;
    font-weight: 600;
  }
  .redColor{
    color: #D94066 !important;
  }
  .greenColor{
    color: #41B37D !important;
  }
  .whiteColor{
    color: #ffffff
  }
}
</style>
